import { useParams } from 'react-router-dom';
import { api } from '../../../utils/api.ts';

export const useCustomerBasis = (props: { customerId?: string } = {}) => {
    const params = useParams<{ customer_id: string }>();
    const { customerId } = props;
    const erpCustomerId = customerId || params.customer_id || '';

    const query = api.platoUser.getDetailCustomer.getBasics.useQuery(
        {
            erpCustomerId,
        },
        {
            enabled: Boolean(erpCustomerId),
        },
    );

    return {
        ...query,
        isLoading: query.isLoading && Boolean(erpCustomerId),
    };
};
